import React from 'react';
export default function CornerIndicator(props) {
  return /*#__PURE__*/React.createElement("th", {
    className: "Spreadsheet__header"
  });
}